import { uploadFileToBizly } from 'api';
import { uploadFile as uploadToCloudinary } from 'cloudinary';
import { UploadedFile } from './FileUploadField';

export type FileUploadStrategy = {
    upload: (file: File, directory: string) => Promise<UploadedFile>;
    getName: () => string;
};

export const UPLOAD_PROVIDER = {
    BIZLY: 'bizly',
    CLOUDINARY: 'cloudinary',
} as const;

export type UploadProvider = (typeof UPLOAD_PROVIDER)[keyof typeof UPLOAD_PROVIDER];

const cloudinaryUploadStrategy: FileUploadStrategy = {
    getName: () => UPLOAD_PROVIDER.CLOUDINARY,

    upload: async (file: File): Promise<UploadedFile> => {
        const result = await uploadToCloudinary(file);

        return {
            id: crypto.randomUUID(),
            url: result.url,
            name: file.name,
            size: result.bytes,
        };
    },
};

const bizlyUploadStrategy: FileUploadStrategy = {
    getName: () => UPLOAD_PROVIDER.BIZLY,

    upload: async (file: File, directory: string): Promise<UploadedFile> => {
        const result = await uploadFileToBizly(file, directory);

        return {
            id: crypto.randomUUID(),
            url: result.data.url,
            name: result.data.filename,
            size: result.data.size,
        };
    },
};

const uploadStrategies: Record<UploadProvider, FileUploadStrategy> = {
    bizly: bizlyUploadStrategy,
    cloudinary: cloudinaryUploadStrategy,
};

export const getUploadStrategy = (provider: UploadProvider): FileUploadStrategy => {
    const strategy = uploadStrategies[provider];

    if (!strategy) {
        throw new Error(`Unknown upload provider: ${provider}`);
    }

    return strategy;
};
